import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

// styling
import styles from './styles.module.scss';

// components
import { toast } from 'react-toastify';

// hooks
import { useForm } from 'react-hook-form';

// utils
import classNames from 'classnames';
import ApiService from './../../network/ApiService';

const UpdatePlayerForm = ({ playerId }) => {
    const [player, setPlayer] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors }, setValue } = useForm({
        defaultValues: {
            number: '',
            email: '',
        }
    });

    useEffect(() => {
        if (!playerId) {
            toast.error("Player ID is missing.");
            setLoading(false);
            return;
        }

        const fetchPlayerData = async () => {
            try {
                const apiService = new ApiService();
                const response = await apiService.get(`app/player/${playerId}`);
                if (response) {
                    setPlayer(response);

                    // Set the form fields with the fetched player data
                    setValue('number', response.number || '');
                    setValue('email', response.email || '');
                }
            } catch (error) {
                toast.error('Failed to fetch player data.');
            } finally {
                setLoading(false);
            }
        };

        fetchPlayerData();
    }, [playerId, setValue]);

    const onSubmit = async (data) => {
        try {
            const apiService = new ApiService();
            await apiService.put(`app/player/${player.id}/email`, {
                email: data.email || player.email,
                player_number: data.number || player.number,
            });
            navigate('/kader');
        } catch (error) {
            toast.error(error.message || 'Failed to update the player information.');
        }
    };

    if (loading) {
        return <p>Loading...</p>;
    }

    if (!player) {
        return <p>Player data not found.</p>;
    }

    return (
        <form className="d-flex flex-column g-20" onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.row}>
                <div>
                    <label htmlFor="number">Nummer</label>
                    <input
                        id="number"
                        className={classNames('field', { 'field--error': errors.number })}
                        type="number"
                        placeholder="Nummer"
                        {...register('number')}
                    />
                </div>
            </div>
            <div className={styles.row}>
                <div className={styles.column}>
                    <label htmlFor="email">Email</label>
                    <input
                        id="email"
                        className={classNames('field', { 'field--error': errors.email })}
                        type="email"
                        placeholder="Email"
                        {...register('email')}
                    />
                </div>
            </div>
            <div className={styles.footer}>
                <button className="btn" type="submit">Update Profile</button>
                {/* Uncomment if you want the reset button */}
                {/*<button className="btn btn--outlined" type="reset" onClick={() => reset()}>Cancel</button>*/}
            </div>
        </form>
    );
};

UpdatePlayerForm.propTypes = {
    playerId: PropTypes.string.isRequired,
};

export default UpdatePlayerForm;
